<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-row justify="center">
          <v-col cols="12" lg="8" md="8" sm="12">
            <v-card color="#393E46">
              <v-card-title>Mis Entradas</v-card-title>
              <v-card-subtitle>Encuentre sus entradas para los eventos que compro, si no lo ve en Activos revise en Pasados , puede afectar la hora que este ingresando al evento </v-card-subtitle>
              <v-card-text>

                    <v-tabs
                          v-model="tab"
                      centered
                      dark
                      icons-and-text
                          background-color="#6D9886"
                          color="#393E46"
                      >
                    <v-tabs-slider></v-tabs-slider>
                        <v-tab href="#tab-porasistir"
                        >
                          Eventos Activos
                          <v-icon>fas fa-ticket-alt</v-icon>
                        </v-tab>
                        <v-tab href="#tab-asistidos">
                          Eventos Pasados
                          <v-icon>fas fa-check-circle</v-icon>
                        </v-tab>


                        <v-tab-item
                        key="tab-porasistir" value="tab-porasistir"
                        >
                          <v-row justify="center" align="center" class="pa-2" style="background-color: #393E46;">

                          <v-col cols="12" lg="6" md="6" sm="12" v-for="ticket in actTickets" :key="ticket.id">
                              <v-card light elevation="10">
                                <v-card-title  justify="center" ><h2 >{{ticket.eventoEntrada.eventoEntradaZonaEvento.zonaEventoEvento.evento}}</h2></v-card-title>
                                <v-card-text >
                                  <v-row >
                                    <v-col cols="12" lg="6" md="6" sm="6">
                                      <p>Zona: {{ticket.eventoEntrada.eventoEntradaZonaEvento.zonaEvento}}</p>
                                      <p>Entrada: {{ticket.eventoEntrada.eventoEntrada}}</p>
                                    </v-col>
                                    <v-col v-if="ticket.estadoEvento.estadoEventoId ===2 || ticket.estadoEvento.estadoEventoId === 4" cols="12" lg="6" md="6" sm="6">
                                      <p><v-btn class="primary" @click="verentrada(ticket)"><v-icon left>
                                        fas fa-qrcode
                                      </v-icon>Ver Entrada</v-btn></p>
                                      <p><v-btn class="secondary" @click="verwallet(ticket)"><v-icon left>
                                        fas fa-wallet
                                      </v-icon>Ver Wallet</v-btn></p>
                                      <p v-if="!ticket.transferido">
                                        <v-btn class="warning" @click="transferencia(item)"><v-icon left>
                                          fas fa-exchange-alt
                                        </v-icon>Transferir</v-btn>
                                      </p>
                                    </v-col>
                                    <v-col v-if="ticket.estadoEvento.estadoEventoId ===1" cols="12" lg="6" md="6" sm="6">
                                      <p>PENDIENTE DE APROBACIÓN</p>
                                    </v-col>
                                    <v-col v-if="ticket.estadoEvento.estadoEventoId ===3" cols="12" lg="6" md="6" sm="6">
                                      <p>RECHAZADO</p>
                                    </v-col>
                                  </v-row>

                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-tab-item>
                      <v-tab-item
                           value="tab-asistidos"

                      >
                        <v-row justify="center" align="center" class="pa-2" style="background-color: #393E46;">
                          <v-col cols="12" lg="6" md="6" sm="12" v-for="ticket in pasTickets" :key="ticket.id">
                            <v-card light elevation="10">
                              <v-card-title  justify="center" ><h2 >{{ticket.eventoEntrada.eventoEntradaZonaEvento.zonaEventoEvento.evento}}</h2></v-card-title>
                              <v-card-text >
                                <v-row >
                                  <v-col cols="12" lg="6" md="6" sm="6">
                                    <p>Zona: {{ticket.eventoEntrada.eventoEntradaZonaEvento.zonaEvento}}</p>
                                    <p>Entrada: {{ticket.eventoEntrada.eventoEntrada}}</p>
                                  </v-col>
                                  <v-col v-if="ticket.estadoEvento.estadoEventoId ===2 || ticket.estadoEvento.estadoEventoId === 4" cols="12" lg="6" md="6" sm="6">
                                    <p><v-btn class="primary" @click="verentrada(ticket)"><v-icon left>
                                      fas fa-qrcode
                                    </v-icon>Ver Entrada</v-btn></p>
                                    <p><v-btn class="secondary" @click="verwallet(ticket)"><v-icon left>
                                      fas fa-wallet
                                    </v-icon>Ver Wallet</v-btn></p>
                                    <p v-if="!ticket.transferido">
                                      <v-btn class="warning" @click="transferencia(item)"><v-icon left>
                                        fas fa-exchange-alt
                                      </v-icon>Transferir</v-btn>
                                    </p>
                                  </v-col>
                                  <v-col v-if="ticket.estadoEvento.estadoEventoId ===1" cols="12" lg="6" md="6" sm="6">
                                    <p>PENDIENTE DE APROBACIÓN</p>
                                  </v-col>
                                  <v-col v-if="ticket.estadoEvento.estadoEventoId ===3" cols="12" lg="6" md="6" sm="6">
                                    <p>RECHAZADO</p>
                                  </v-col>
                                </v-row>

                              </v-card-text>
                            </v-card>
                          </v-col></v-row>
                      </v-tab-item>
                      </v-tabs>


              </v-card-text>

            </v-card>
          </v-col>

        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>

import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from "axios";
import moment from "moment";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'tickets',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
   overlay: false,
    tab: null,
    token:'',
    date1: new Date(),
    actTickets:[],
    pasTickets:[]
  }),
  mounted() {

    if (this.usuario.id === undefined){

      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

              this.getTickets()
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.getTickets()

    }
  },
  watch:{
    '$store.state.usuario': function (){
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else{
        this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

        this.getTickets()
      }

    }
  },
  methods:{
    getTickets(){
      this.overlay = true
      axios.get("tickets/"+this.usuario.id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.overlay = false
            response.data.forEach((entry)=>{
                let fechaIn = new Date(entry.eventoEntrada.fechaInicio)
                  console.log(fechaIn)
              entry.url = process.env.VUE_APP_API+"passkit/"+entry.id
                  if (fechaIn >= this.date1){

                    this.actTickets.push(entry)
                  }else{
                    this.pasTickets.push(entry)
                  }
                })
          })
          .catch(function (error){
            if(error.response.status ===401){
              window.location.reload();

            }
          })

    },

    verwallet(ticket){
      axios
          .get( 'passkit/'+ticket.codigoUnico,{
            responseType: 'arraybuffer',
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              }
          )
          .then(response=>{
            const reader = new FileReader();
            const out = new Blob([response.data], {
              type: "application/vnd.apple.pkpass",
            });
            reader.onload = function () {
              if (reader.result !== null) {
                window.location.href = reader.result.toString();
              }
            };
            reader.readAsDataURL(out);
          })
          .catch(() => console.log('error occured'))
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    verentrada(ticket){
      store.dispatch("fetchTicket",ticket)
      this.$router.push({ path: '/entrada' });
    },

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>